export default __webpack_public_path__ + "static/media/d2.43c31b42.png";